// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1u9Nh","inputWrap":"CustomTip_inputWrap__1Nkxw"};